import { useRef, useState } from "react";
import { motion } from "framer-motion";

const enter = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 0.61, 0.36, 1] } } };

export default function NumberStep({ chapter, title, hint, value, onChange, onSubmit, onBack, placeholder, min = 1, testId, preview }) {
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  function submit(e) {
    e.preventDefault();
    const n = Number(value);
    if (value === "" || Number.isNaN(n) || n < min) {
      setError(`Escribe un número válido (mínimo ${min.toLocaleString("en-US")}).`);
      inputRef.current?.focus();
      return;
    }
    setError("");
    onSubmit(n);
  }

  return (
    <section className="step" data-testid={testId}>
      <motion.div className="step-inner" variants={enter} initial="hidden" animate="show">
        <p className="eyebrow">
          <span className="mk-estrella" aria-hidden="true" /> Pregunta {chapter} de 6
        </p>
        <h2 className="q-title display">{title}</h2>
        {hint && <p className="hint">{hint}</p>}
        <form className="campo-form" onSubmit={submit} noValidate data-testid={`${testId}-form`}>
          <input
            ref={inputRef}
            id={`${testId}-input`}
            data-testid={`${testId}-input`}
            className="campo-input"
            type="number"
            inputMode="numeric"
            min={min}
            step="1"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            aria-label={title}
            autoFocus
          />
          {preview}
          {error && (
            <p className="error" role="alert" data-testid={`${testId}-error`}>
              {error}
            </p>
          )}
          <div className="form-actions">
            <button type="button" className="backlink" onClick={onBack} data-testid={`${testId}-volver`}>
              Atrás
            </button>
            <button type="submit" className="btn btn-cta" data-testid={`${testId}-continuar`}>
              Siguiente
            </button>
          </div>
        </form>
      </motion.div>
    </section>
  );
}
